import { render, staticRenderFns } from "./GPDan.vue?vue&type=template&id=5c12d48c&scoped=true"
import script from "./GPDan.vue?vue&type=script&lang=js"
export * from "./GPDan.vue?vue&type=script&lang=js"
import style0 from "./GPDan.vue?vue&type=style&index=0&id=5c12d48c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c12d48c",
  null
  
)

export default component.exports